import { FacilityTypeEnum } from '../enums/facility-type';

class FacilityType {
  translatedType = '';

  facilityType: FacilityTypeEnum = FacilityTypeEnum.other;

  constructor(facilityType: FacilityTypeEnum) {
    this.facilityType = facilityType;
  }
}

export default FacilityType;
